import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

export const StyledSignalsCardEmptyWrapper = styled(Flex)`
    img {
        height: 143px;
    }

    span {
        font-weight: 400;
        text-align: center;
    }
`;
